// src/login/LoginScreen.jsx
import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { LOGIN_END_POINT, BASE_URL } from '../utils/api';

function LoginScreen() {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Log once so you can confirm the API is correct
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('LOGIN_END_POINT =', LOGIN_END_POINT);
    // eslint-disable-next-line no-console
    console.log('BASE_URL =', BASE_URL);
  }, []);

  const validate = useCallback(() => {
    if (!mobile.trim() || !password.trim()) {
      alert('Please enter both mobile and password.');
      return false;
    }
    return true;
  }, [mobile, password]);

  const handleLogin = useCallback(async () => {
    if (loading) return;
    if (!validate()) return;

    try {
      setLoading(true);
      const res = await axios.post(LOGIN_END_POINT, {
        mobile: mobile.trim(),
        password: password.trim(),
      });

      if (res.data?.success && res.data?.token) {
        localStorage.setItem('token', res.data.token);
        const from = location.state?.from?.pathname || '/dashboard';
        navigate(from, { replace: true });
      } else {
        alert(res.data?.message || 'Invalid credentials');
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Login Error:', err?.response || err);
      alert(
        err?.response?.data?.message ||
        err?.message ||
        'Login failed. Please try again later.'
      );
    } finally {
      setLoading(false);
    }
  }, [loading, validate, mobile, password, navigate, location.state]);

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLogin();
    }
  };

  const resetSession = () => {
    localStorage.removeItem('token');
    window.location.reload();
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4 w-100" style={{ maxWidth: '400px' }}>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h3 className="mb-0">Visitor Login</h3>
          <button className="btn btn-sm btn-outline-secondary" onClick={resetSession}>
            Reset Session
          </button>
        </div>

        <div className="mb-3">
          <label className="form-label">Mobile Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter mobile"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            onKeyDown={onKeyDown}
            disabled={loading}
            inputMode="numeric"
            autoComplete="tel"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={onKeyDown}
            disabled={loading}
            autoComplete="current-password"
          />
        </div>

        <button className="btn btn-primary w-100" onClick={handleLogin} disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </div>
    </div>
  );
}

export default LoginScreen;
